import { useConfirmModal } from "@/composables/useConfirmModal";
import { useToastTransaction } from "@/composables/useToast/useToastTransaction";
import { isApprovedForApes } from "@/helpers/utils";
import {
  useBapApesContract,
  useAssetsInteractionsContract,
} from "@/web3/contracts";

const { useWeb3Store } = require("@/store/web3");

export const approveApes = async function (purpose) {
  const walletAddress = useWeb3Store().walletAddress;
  const isApproved = await isApprovedForApes(walletAddress);
  if (isApproved) return true;
  const userAgrees = await useConfirmModal({
    title: "Contract needs your approval",
    text: `The Contract requires your approval to use your Apes tokens
            <br>This is required in order to ${purpose}
            <br>After you approve the Contract, the process will continue as usual`,
  });
  if (!userAgrees) return false;

  const contract = useBapApesContract(true);

  const approveForAllResponse = await useToastTransaction(
    contract.methods.setApprovalForAll(useAssetsInteractionsContract().options.address, true),
    {
      text: "Approving Apes Contract",
      successText: "You have successfully approved the Apes Contract",
    }
  );
  return approveForAllResponse;
};
